<script>
export default {
    name: 'Utility',

    data() {
        return {}
    },
    methods: {
        numberWithCommas(number) {
            if (number == undefined) {
                return;
            }
            return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },

        numberSetPrecision(number, precision) {
            return (Math.round(number * 100000000000) / 100000000000).toFixed(precision);
        },

        slugToTitle(slug) {

            var split = slug.split('-');
            var result = "";
            for (var i = 1; i < split.length; i++) {
                result += split[i][0].toUpperCase() + split[i].substring(1) + " ";
            }
            return result;
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
}
</script>
